import React from 'react'
import { ILoadingCellRendererParams } from 'ag-grid-community'

interface TreeChildLoadingCellProps extends ILoadingCellRendererParams {
  /** What the row says while the children are on their way. */
  text?: string
}

/**
 * The loading row of a child level. AG Grid's own loading renderer reads its text from
 * localeText.loadingOoo and consults nothing about the row, so the children of an expanded row would
 * announce themselves with the text of the list itself.
 *
 * Mirrors the markup of that renderer — div.ag-loading with an icon and a text span, the icon class
 * being what groupLoading maps to — so the row is indistinguishable from the list's own loading row.
 * No JSS here on purpose: every class belongs to ag-grid and is styled by its theme.
 */
const TreeChildLoadingCell = ({ text }: TreeChildLoadingCellProps) => (
  <div className='ag-loading'>
    <span className='ag-loading-icon'>
      <span className='ag-icon ag-icon-loading' role='presentation' />
    </span>
    {Boolean(text) && (
      <span className='ag-loading-text' data-qs-id='tree-child-loading-text'>{text}</span>
    )}
  </div>
)

export default TreeChildLoadingCell
